module.exports = __webpack_public_path__ + "Flag-60.272ea78c65a101fe66bc509ee82691b8.svg";